import React from 'react'
import {message, Popconfirm} from 'antd';
import UserStore from 'stores/UserStore';

class ManageEmails extends React.Component {

    handleClick = () => {
        UserStore.removeMobile(this.props.id)
            .then(() => {
                this.props.handleRemove(this.props.index);
                this.props.updateData();
            }).catch(() => {
            message.error('Error');
        })
    }

    render() {
        return (
            <React.Fragment>
                <Popconfirm title={`Are you sure you want to remove the mobile ${this.props.mobile}?`} onConfirm={this.handleClick}
                            okText="Yes" cancelText="No">
                    <span className={'link'}>Remove</span>
                </Popconfirm>
            </React.Fragment>
        )
    }

}

export default ManageEmails;
